import { Component } from "react";

import { apiResponseToast } from "../../assets/Js/apiResponseToast";

import { getPlainToken } from "../../assets/Js/tokenHandler";

import { callAPI } from "../../assets/Js/backendCommunication";

import projectSettings from "../../assets/Js/projectSettings";

import { Spinner } from "../../Components/Spinner/Spinner";

export default class SubscribeToPlateform extends Component {
  constructor(props) {
    super(props);

    this.state = {
      isStripeLoading: false,
    };
  }

  sessionSubscription = async () => {
    let url = `${projectSettings.baseUrl}/subscriptions/create`;
    let header = true;
    let type = "POST";
    let token = getPlainToken();
    let data = null;
    let response = "";

    if (response === "") {
      this.setState({ isLoadingSubscription: true });
    }

    response = await callAPI(url, header, type, JSON.stringify(data), token);

    if (response) {
      apiResponseToast(
        response.status,
        "subscribeWithStripe",
        response.data.message
      );
      this.setState({ isLoadingSubscription: false });
      if (response.type === "error") {
      } else if (response.type === "success") {
        window.location.replace(response.data.sessionUrl);
      }
    }
  };

  render() {
    return (
      <button
        className="basicFatBtnStyle primaryBtn size200-35"
        disabled={this.isLoadingSubscription}
        onClick={this.sessionSubscription}
      >
        {this.state.isLoadingSubscription ? (
          <div>
            <Spinner />
          </div>
        ) : (
          <span>Subscribe</span>
        )}
      </button>
    );
  }
}
